import React from "react";
import PolicyPage from "./PolicyPage";
import { policies } from "../Datas/policyData";

function Privacy() {
  return <PolicyPage policy={policies.privacy} />;
}

export default Privacy;
